export default "__VITE_ASSET__CaFDCyDW__"